import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import "../../assets/scss/custom/pages/_email_custom.scss";
import { Row, Container, Col, FormGroup, Input, FormFeedback, Spinner } from "reactstrap";
//Import Breadcrumb
// Import Images
import dots from "../../assets/images/more_horiz_black_20dp.png";
import { EditorState, convertFromRaw, ContentState, convertFromHTML, Modifier, convertToRaw, draftToHtml } from "draft-js";
import styled from "styled-components";
import EmailContent from "./components/EmailContent";

// import Editor, { Component } from "react";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import Editor, { createEditorStateWithText } from "draft-js-plugins-editor";
import createEmojiPlugin from "draft-js-emoji-plugin";
import "draft-js-emoji-plugin/lib/plugin.css";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import { ItalicButton, BoldButton, UnderlineButton } from "draft-js-buttons";
import "./../E-mail/Editor/editor/customtoolbar.scss";
// Editor
import "./../E-mail/Editor/content/content.scss";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  copyMailPromise,
  createLog,
  sendMailPromise,
  updateCompanyTokenUsage,
  createAiTextImprovementFunctionExecution,
  createAIResponseExecution,
  translateWithDeepLPromise,
  sendMailDirect
} from "../../helpers/api_helper";
import { useMixpanel } from "../../Hooks/useMixpanel";
import { stateToHTML } from "draft-js-export-html";

const emojiPlugin = createEmojiPlugin();
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;

const toolbarPlugin = createToolbarPlugin();
const { Toolbar } = toolbarPlugin;
const plugins = [toolbarPlugin, emojiPlugin];
const text = "";

const EmailRedact = (props) => {
  const { create_message_modal_visibility, setCreateMessageModalVisibility, setToastMessage, toggleToast } = props;
  // New Editor
  const [customEditorState, setCustomEditorState] = useState(createEditorStateWithText(text));
  const [send_email_request, setSendEmailRequestValue] = useState(false);

  const { mixPanelTrack } = useMixpanel();

  const editorRef = useRef(null);

  const focusEditor = () => {
    editorRef.current.focus();
  };

  const handleFileSelect = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      console.log("Fichier sélectionné :", file);
    };
    fileInput.click();
  };

  const messageValidation = useFormik({
    initialValues: {
      toEmail: props.toEmail ?? undefined,
      cc: undefined,
      objet: undefined,
      text: undefined
    },
    validationSchema: Yup.object({
      toEmail: Yup.string().required(props.t("Veuillez entrer email du destinataire")).email(props.t("Veuillez entrer un email valide")),
      objet: Yup.string().required(props.t("Veuillez entrer l'objet")),
      text: Yup.string().required(props.t("Veuillez entrer le message"))
    }),
    onSubmit: (values) => {
      sendEmail(values);
    }
  });

  async function sendEmail(values) {
    const contentState = customEditorState.getCurrentContent();
    const rawHtml = stateToHTML(contentState);
    console.log({ sendMail: rawHtml });
    onSendEmailRequestChange(true);

    const company_id = localStorage.getItem("companyId");

    const data = {
      to: values.toEmail,
      cc: values.cc,
      subject: values.objet,
      company_id: company_id,
      // text: values.text,
      text: rawHtml,
      email_id: localStorage.getItem("selected_mail_box")
    };

    sendMailDirect(data).then(async (response) => {
      if (response && !response.includes("error")) {
        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id: company_id,
          is_ai: false,
          receiver: values.toEmail,
          subject: values.objet
        };
        let logdata = {
          event: "mail_send_direct",
          author_id: user_id,
          company_id: company_id,
          log_data: JSON.stringify(logData)
        };
        createLog(logdata, mixPanelTrack);

        onMessageCreateModalVisibility();
        onSendEmailRequestChange(false);
        setToastMessage({ title: props.t("Succès"), body: props.t("Message envoyé"), key: "success" });
        toggleToast();
      } else {
        onSendEmailRequestChange(false);
        setToastMessage({ title: props.t("Echec"), body: props.t("Erreur inattendu, veuillez réessayer"), key: "danger" });
        toggleToast();
      }
    });
  }

  function onMessageCreateModalVisibility() {
    setCreateMessageModalVisibility(!create_message_modal_visibility);
  }

  const onSendEmailRequestChange = (value) => {
    setSendEmailRequestValue(value);
  };

  return (
    <React.Fragment>
      <div
        className="d-flex flex-column"
        style={{
          //    overflowY: "auto",
          //  height: "70.7vh",
          borderTopColor: "#dcdcdc",
          borderTopWidth: props.showReadEmailView ? "2px" : "0px",
          borderTopStyle: "solid",
          paddingTop: "20px",
          marginTop: "5px",
          paddingRight: "10px"
        }}>
        <div
          style={{
            position: "relative"
          }}>
          <Col xl={12} className="mb-3">
            <div className="w-100">
              <div>
                <Row>
                  <Col style={{ marginLeft: "10px", marginBottom: "10px", alignContent: "center" }}>{props.t("A")} :</Col>
                  <Col lg={10}>
                    <FormGroup>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-lastname-input22"
                        name="toEmail"
                        placeholder={props.t("Destinataire")}
                        onChange={messageValidation.handleChange}
                        onBlur={messageValidation.handleBlur}
                        value={messageValidation.values && messageValidation.values.toEmail}
                        invalid={messageValidation.errors.toEmail}></Input>
                      {messageValidation.errors.toEmail ? (
                        <FormFeedback type="invalid">
                          <div>{messageValidation.errors.toEmail}</div>
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div style={{ marginTop: "10px" }}>
                <Row>
                  <Col style={{ marginLeft: "10px", marginBottom: "10px", alignContent: "center" }}>{props.t("CC")} :</Col>
                  <Col lg={10}>
                    <FormGroup>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-lastname-input22"
                        name="cc"
                        placeholder={props.t("Copie")}
                        onChange={messageValidation.handleChange}
                        onBlur={messageValidation.handleBlur}
                        value={messageValidation.values && messageValidation.values.cc}
                        invalid={messageValidation.errors.cc}></Input>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div style={{ marginTop: "10px" }}>
                <Row>
                  <Col style={{ marginLeft: "10px", marginBottom: "10px", alignContent: "center" }}>{props.t("Objet")} :</Col>
                  <Col lg={10}>
                    <FormGroup>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-lastname-input22"
                        name="objet"
                        placeholder={props.t("Objet")}
                        onChange={messageValidation.handleChange}
                        onBlur={messageValidation.handleBlur}
                        value={messageValidation.values && messageValidation.values.objet}
                        invalid={messageValidation.errors.objet}></Input>
                      {messageValidation.errors.objet ? (
                        <FormFeedback type="invalid">
                          <div>{messageValidation.errors.objet}</div>
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div className="grid-content">
                <div className="grid-item">
                  <div className="editor-content">
                    <div className="editor" onClick={focusEditor} style={{ paddingTop: "0", marginBottom: "0" }}>
                      <div style={{ height: "300px" }}>
                        <Editor
                          placeholder={props.t("Tapez un Message")}
                          editorState={customEditorState}
                          onChange={(customEditorState) => {
                            setCustomEditorState(customEditorState);
                            const contentState = customEditorState.getCurrentContent();
                            const plainText = contentState.getPlainText();
                            messageValidation.setFieldValue("text", plainText);
                          }}
                          plugins={plugins}
                          ref={editorRef}
                          readOnly={false}
                        />
                      </div>

                      <div className="custom-toolbar">
                        <Toolbar>
                          {
                            // may be use React.Fragment instead of div to improve perfomance after React 16
                            (externalProps) => (
                              <div
                                style={{
                                  paddingTop: "8px",
                                  paddingBottom: "8px",
                                  borderTop: "1px solid #E3E8E7",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                <div className="d-flex align-items-center">
                                  <BoldButton {...externalProps} />
                                  <ItalicButton {...externalProps} />
                                  <UnderlineButton {...externalProps} />
                                  {/* <CodeButton {...externalProps} />  */}
                                  <Separator {...externalProps} />
                                  <EmojiSelect />
                                  <EmojiSuggestions />
                                  <button
                                    className="fileChooser d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "36px",
                                      height: "34px",
                                      border: "none"
                                    }}
                                    onClick={handleFileSelect}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                                      <path
                                        d="M14.3799 7.68305C14.438 7.7411 14.4841 7.81003 14.5156 7.8859C14.547 7.96178 14.5632 8.04311 14.5632 8.12524C14.5632 8.20738 14.547 8.28871 14.5156 8.36458C14.4841 8.44045 14.438 8.50939 14.3799 8.56743L7.96974 14.9737C7.14912 15.7942 6.03617 16.2551 4.87571 16.255C3.71526 16.255 2.60236 15.7939 1.78185 14.9733C0.961334 14.1527 0.500415 13.0397 0.500488 11.8793C0.500562 10.7188 0.961621 9.60591 1.78224 8.7854L9.53693 0.916649C10.1228 0.330168 10.9176 0.000439978 11.7466 4.39999e-07C12.5756 -0.000439098 13.3708 0.328446 13.9572 0.914305C14.5437 1.50016 14.8734 2.29501 14.8739 3.12398C14.8743 3.95295 14.5454 4.74814 13.9596 5.33462L6.20333 13.2034C5.85109 13.5556 5.37335 13.7535 4.87521 13.7535C4.37706 13.7535 3.89932 13.5556 3.54708 13.2034C3.19484 12.8511 2.99695 12.3734 2.99695 11.8752C2.99695 11.3771 3.19484 10.8994 3.54708 10.5471L10.0549 3.93618C10.1119 3.87537 10.1805 3.82657 10.2566 3.79266C10.3328 3.75876 10.415 3.74043 10.4983 3.73875C10.5816 3.73707 10.6645 3.75208 10.7419 3.7829C10.8194 3.81371 10.8899 3.85971 10.9493 3.91818C11.0087 3.97665 11.0558 4.04641 11.0879 4.12336C11.1199 4.20031 11.1362 4.2829 11.1359 4.36625C11.1355 4.44961 11.1185 4.53205 11.0858 4.60873C11.0531 4.68541 11.0054 4.75477 10.9455 4.81274L4.43693 11.4307C4.37865 11.4885 4.33233 11.5572 4.30062 11.633C4.26891 11.7087 4.25241 11.7899 4.25209 11.872C4.25176 11.9541 4.26761 12.0354 4.29872 12.1114C4.32983 12.1873 4.3756 12.2564 4.43341 12.3147C4.49122 12.373 4.55995 12.4193 4.63566 12.451C4.71137 12.4827 4.79259 12.4992 4.87467 12.4995C4.95676 12.4999 5.03811 12.484 5.11407 12.4529C5.19003 12.4218 5.25912 12.376 5.31739 12.3182L13.0729 4.45337C13.4251 4.10185 13.6233 3.62481 13.6238 3.12718C13.6243 2.62955 13.4271 2.15209 13.0756 1.79985C12.7241 1.44761 12.247 1.24944 11.7494 1.24892C11.2518 1.24841 10.7743 1.4456 10.4221 1.79712L2.66896 9.66274C2.37851 9.95273 2.14802 10.2971 1.99066 10.6761C1.83329 11.0552 1.75213 11.4615 1.7518 11.872C1.75148 12.2824 1.83199 12.6889 1.98875 13.0682C2.14552 13.4475 2.37546 13.7922 2.66544 14.0827C2.95543 14.3731 3.29978 14.6036 3.67884 14.761C4.0579 14.9183 4.46425 14.9995 4.87467 14.9998C5.2851 15.0001 5.69158 14.9196 6.07089 14.7629C6.4502 14.6061 6.79492 14.3762 7.08536 14.0862L13.4963 7.67993C13.6139 7.56322 13.7731 7.49799 13.9387 7.49858C14.1044 7.49916 14.2631 7.56552 14.3799 7.68305Z"
                                        fill="#272B35"
                                      />
                                    </svg>
                                  </button>
                                  <Separator {...externalProps} />
                                  {/* <button
                                      className="moreButton d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "36px",
                                        height: "34px",
                                        border: "none",
                                      }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="17" viewBox="0 0 6 17" fill="none">
                                        <path
                                          d="M5.1875 8.4375C5.1875 8.87015 5.05921 9.29308 4.81884 9.65281C4.57848 10.0125 4.23683 10.2929 3.83712 10.4585C3.43741 10.6241 2.99757 10.6674 2.57324 10.583C2.14891 10.4986 1.75913 10.2902 1.45321 9.9843C1.14728 9.67837 0.938938 9.2886 0.854533 8.86426C0.770128 8.43993 0.813448 8.0001 0.979015 7.60038C1.14458 7.20067 1.42496 6.85903 1.78469 6.61866C2.14442 6.3783 2.56735 6.25 3 6.25C3.58016 6.25 4.13656 6.48047 4.5468 6.89071C4.95703 7.30094 5.1875 7.85734 5.1875 8.4375ZM3 4.375C3.43265 4.375 3.85558 4.24671 4.21531 4.00634C4.57504 3.76598 4.85542 3.42433 5.02099 3.02462C5.18655 2.62491 5.22987 2.18507 5.14547 1.76074C5.06106 1.33641 4.85273 0.946632 4.5468 0.640705C4.24087 0.334778 3.85109 0.126438 3.42676 0.0420332C3.00243 -0.042372 2.56259 0.000947807 2.16288 0.166515C1.76317 0.332081 1.42153 0.612459 1.18116 0.972191C0.940796 1.33192 0.812501 1.75485 0.812501 2.1875C0.812501 2.76766 1.04297 3.32406 1.45321 3.7343C1.86344 4.14453 2.41984 4.375 3 4.375ZM3 12.5C2.56735 12.5 2.14442 12.6283 1.78469 12.8687C1.42496 13.109 1.14458 13.4507 0.979015 13.8504C0.813448 14.2501 0.770128 14.6899 0.854533 15.1143C0.938938 15.5386 1.14728 15.9284 1.45321 16.2343C1.75913 16.5402 2.14891 16.7486 2.57324 16.833C2.99757 16.9174 3.43741 16.8741 3.83712 16.7085C4.23683 16.5429 4.57848 16.2625 4.81884 15.9028C5.05921 15.5431 5.1875 15.1201 5.1875 14.6875C5.1875 14.1073 4.95703 13.5509 4.5468 13.1407C4.13656 12.7305 3.58016 12.5 3 12.5Z"
                                          fill="#758A89"
                                        />
                                      </svg>
                                    </button> */}

                                  <div>
                                    {/* <Dropdown
                                      isOpen={ai_action_menu}
                                      // disabled={props.client_data && props.client_data.plan_id && props.client_data.plan_id === "free"}
                                      toggle={() => setAiActionMenu(!ai_action_menu)}
                                      className="user-dropdown d-inline-block ">
                                      <DropdownToggle className="p-0 bg-transparent border-0" id="ia-dropdown" tag="button">
                                        <button
                                          className="aiButton d-flex align-items-center justify-content-center"
                                          style={{
                                            width: "36px",
                                            height: "34px",
                                            border: "none",
                                          }}
                                          // onClick={() => getAIResponse()}
                                          disabled={instruction_request}>
                                          {instruction_request ? (
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                          ) : (
                                            <img
                                              src={logo_smartas_1}
                                              alt="aiButton__icon"
                                              style={{
                                                width: "auto",
                                                height: "24px",
                                              }}
                                            />
                                          )}
                                        </button>
                                      </DropdownToggle>
                                      <DropdownMenu className="font-primary simple-text px-2" style={{ width: "25rem", textAlign: "start" }}>
                                        <div id="aiTextImprovement">
                                          <DropdownItem
                                            id="ImproveStyle"
                                            style={{
                                              textAlign: "start",
                                              cursor: aiImprovmentsDisabled.value ? "not-allowed" : "pointer",
                                              opacity: aiImprovmentsDisabled.value ? 0.65 : 1,
                                            }}
                                            onClick={!aiImprovmentsDisabled.value ? () => getAiTextImprovement("styling") : null}>
                                            <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                              <i className="mdi mdi-compass-rose" style={{ color: "#272b35", fontSize: "1.3rem" }}></i>
                                              <span
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "1rem",
                                                }}>
                                                {props.t("ImproveStyle")}
                                              </span>
                                            </div>
                                          </DropdownItem>
                                          {aiImprovmentsDisabled.reason && (
                                            <UncontrolledTooltip
                                              innerClassName="custom-inner-tooltip"
                                              popperClassName="ms-2 custom-tooltip"
                                              placement="right"
                                              target={"ImproveStyle"}>
                                              {aiImprovmentsDisabled.reason}
                                            </UncontrolledTooltip>
                                          )}
                                          <DropdownItem divider />

                                          <DropdownItem
                                            id="TranslateInputText"
                                            style={{
                                              textAlign: "start",
                                              cursor: aiImprovmentsDisabled.value ? "not-allowed" : "pointer",
                                              opacity: aiImprovmentsDisabled.value ? 0.65 : 1,
                                            }}
                                            onClick={() => (!aiImprovmentsDisabled.value ? getAiTextImprovement("translation") : null)}>
                                            <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" id="translate">
                                                <path fill="none" d="M0 0h24v24H0V0z"></path>
                                                <path d="M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54 0 .99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54 0-.99.45-.99.99 0 .55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69 0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03 0 1.42.39.39 1.02.39 1.42 0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6 0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39 0 .74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65 0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7l1.62-4.33L19.12 17h-3.24z"></path>
                                              </svg>

                                              <span
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "1rem",
                                                }}>
                                                {props.t("TranslateInputText")}
                                              </span>
                                            </div>
                                          </DropdownItem>
                                          {aiImprovmentsDisabled.reason && (
                                            <UncontrolledTooltip
                                              innerClassName="custom-inner-tooltip"
                                              popperClassName="ms-2 custom-tooltip"
                                              placement="right"
                                              target={"TranslateInputText"}>
                                              {aiImprovmentsDisabled.reason}
                                            </UncontrolledTooltip>
                                          )}
                                          <DropdownItem divider />

                                          <DropdownItem
                                            id="CorrectGrammar"
                                            style={{
                                              textAlign: "start",
                                              cursor: aiImprovmentsDisabled.value ? "not-allowed" : "pointer",
                                              opacity: aiImprovmentsDisabled.value ? 0.65 : 1,
                                            }}
                                            onClick={() => (!aiImprovmentsDisabled.value ? getAiTextImprovement("grammar") : null)}>
                                            <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                  d="M4 13L9 18L15 11.4545M20 6L17.25 9"
                                                  stroke="#272b35"
                                                  strokeWidth="1.5"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>

                                              <span
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "1rem",
                                                }}>
                                                {props.t("CorrectGrammar")}
                                              </span>
                                            </div>
                                          </DropdownItem>
                                          {aiImprovmentsDisabled.reason && (
                                            <UncontrolledTooltip
                                              innerClassName="custom-inner-tooltip"
                                              popperClassName="ms-2 custom-tooltip"
                                              placement="right"
                                              target={"CorrectGrammar"}>
                                              {aiImprovmentsDisabled.reason}
                                            </UncontrolledTooltip>
                                          )}
                                          <DropdownItem divider />

                                          <DropdownItem
                                            id="Shorten"
                                            style={{
                                              textAlign: "start",
                                              cursor: aiImprovmentsDisabled.value ? "not-allowed" : "pointer",
                                              opacity: aiImprovmentsDisabled.value ? 0.65 : 1,
                                            }}
                                            onClick={() => (!aiImprovmentsDisabled.value ? getAiTextImprovement("reduce") : null)}>
                                            <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                              <svg width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21 6H17M13 6H3M3 12H11M3 18H16" stroke="#272b35" strokeWidth="1.5" strokeLinecap="round" />
                                              </svg>

                                              <span
                                                style={{
                                                  textAlign: "start",
                                                  fontSize: "1rem",
                                                }}>
                                                {props.t("Shorten")}
                                              </span>
                                            </div>
                                          </DropdownItem>
                                          {aiImprovmentsDisabled.reason && (
                                            <UncontrolledTooltip
                                              innerClassName="custom-inner-tooltip"
                                              popperClassName="ms-2 custom-tooltip"
                                              placement="right"
                                              target={"Shorten"}>
                                              {aiImprovmentsDisabled.reason}
                                            </UncontrolledTooltip>
                                          )}
                                          <DropdownItem divider />
                                        </div>

                                        <DropdownItem
                                          id="aiTextSuggestion"
                                          style={{
                                            textAlign: "start",
                                            cursor: aiSuggestionDisabled.value ? "not-allowed" : "pointer",
                                            opacity: aiSuggestionDisabled.value ? 0.65 : 1,
                                          }}
                                          onClick={aiSuggestionDisabled.value ? undefined : getAIResponse}>
                                          <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                            <img
                                              src={logo_smartas_1}
                                              alt="aiButton__icon"
                                              style={{
                                                width: "auto",
                                                height: "24px",
                                                paddingLeft: "5px",
                                                filter: "grayscale(90%)",
                                              }}
                                            />
                                            <span
                                              style={{
                                                textAlign: "start",
                                                fontSize: "1rem",
                                              }}>
                                              {props.t("SuggestResponse")}
                                            </span>
                                          </div>
                                        </DropdownItem>
                                        {aiSuggestionDisabled.reason && (
                                          <UncontrolledTooltip
                                            innerClassName="custom-inner-tooltip"
                                            popperClassName="ms-2 custom-tooltip"
                                            placement="right"
                                            target={"aiTextSuggestion"}>
                                            {aiSuggestionDisabled.reason}
                                          </UncontrolledTooltip>
                                        )}
                                      </DropdownMenu>
                                    </Dropdown> */}
                                  </div>
                                </div>
                                <div className="sendEmail___button-container">
                                  <button
                                    type="submit"
                                    className={`sendEmail___button ${send_email_request ? "disabled" : ""}`}
                                    onClick={() => {
                                      console.log({ submit: "submitting" });
                                      messageValidation.handleSubmit();
                                      // sendEmail(messageValidation.values);
                                    }}>
                                    {send_email_request ? (
                                      <div style={{ textAlign: "center" }}>
                                        <Spinner
                                          className="me-1"
                                          style={{ height: "15px", color: "#563bff", width: "15px", fontSize: "14px" }}
                                          animation="border"
                                        />
                                      </div>
                                    ) : (
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                        <path
                                          d="M20 10.9876C20.0007 11.2676 19.9253 11.5427 19.7814 11.7845C19.6376 12.0263 19.4306 12.2259 19.1819 12.3628L2.38813 21.7937C2.14685 21.9281 1.87438 21.9991 1.597 22C1.34121 21.9995 1.08926 21.9388 0.862293 21.8229C0.63532 21.7071 0.439933 21.5395 0.292509 21.3341C0.145084 21.1288 0.0499191 20.8918 0.0149899 20.643C-0.0199393 20.3941 0.0063857 20.1406 0.0917579 19.9038L2.8272 12.0504C2.85416 11.9727 2.90521 11.9052 2.9732 11.8575C3.04118 11.8097 3.12269 11.7841 3.20626 11.7842H10.3984C10.5081 11.7844 10.6167 11.7625 10.7174 11.7198C10.8181 11.6771 10.9088 11.6145 10.9838 11.5359C11.0588 11.4574 11.1166 11.3645 11.1536 11.263C11.1905 11.1616 11.2058 11.0538 11.1986 10.9463C11.1804 10.7442 11.0852 10.5563 10.932 10.4203C10.7788 10.2842 10.579 10.21 10.3724 10.2125H3.21327C3.12981 10.2127 3.0484 10.1872 2.98042 10.1396C2.91245 10.0921 2.86133 10.0248 2.8342 9.94731L0.0897575 2.08899C-0.0171174 1.78787 -0.0281984 1.46194 0.0579862 1.15449C0.144171 0.847039 0.323543 0.57261 0.572284 0.367645C0.821024 0.162679 1.12736 0.0368764 1.45062 0.00694133C1.77388 -0.0229937 2.09876 0.0443556 2.38213 0.200046L19.1849 9.61922C19.432 9.75589 19.6377 9.95462 19.781 10.1951C19.9242 10.4355 19.9998 10.709 20 10.9876Z"
                                          fill="#563BFF"
                                        />
                                      </svg>
                                    )}
                                  </button>
                                </div>
                              </div>
                            )
                          }
                        </Toolbar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(EmailRedact);

async function handleMessageTraduction(text, target_lang) {
  try {
    const response = await translateWithDeepLPromise(text, transformLangCodeToISO(target_lang));
    const formatedResponse = JSON.parse(response);
    return formatedResponse.text;
  } catch (error) {
    console.log({ error });
    return null;
  }
}
function transformLangCodeToISO(langCode) {
  // Vérifie si le code de langue est "en" ou "pt" et transforme en code ISO adapté
  if (langCode === "en") {
    return "en-US";
  } else if (langCode === "pt") {
    return "pt-PT";
  } else {
    // Retourne le code de langue original si ce n'est ni "en" ni "pt"
    return langCode;
  }
}
